<template>
    <div class="nrk">
        <Details  :data='data'/>
    </div>
</template>

<script>
 import{mapState} from'vuex';
export default {
    activated() {
        this.$store.dispatch('PostNewsInfo',{id:this.$route.query.id});
    },
    computed:{
        ...mapState({
            data:state=>state.share.NewsInfo,
        })
    },
}
</script>

<style>

</style>